import { useState } from 'react';
import { Box, Typography, Chip, Link } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import './CredentialCard.scss';

export default function CredentialCard({ data }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const maxContactsToShow = 2;
    const displayedContacts = data.contacts.slice(0, maxContactsToShow);
    const remainingContacts = data.contacts.length - displayedContacts.length;

    const WORD_LIMIT = 65;
    const fullDescription = String(data.description || "").replace(/<[^>]+>/g, "").trim();
    const words = fullDescription.split(/\s+/).filter(Boolean);
    const isLong = words.length > WORD_LIMIT;
    const shortDescription = isLong ? words.slice(0, WORD_LIMIT).join(" ") : fullDescription;
    const renderedDescription = isExpanded || !isLong ? fullDescription : `${shortDescription}...`;

    const handleOpenUrl = () => {
        const url = data?.url || data?.URL;
        if (!url) return;
        try {
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (e) {
            // no-op
        }
    };

    return (
        <Box
            className="credential-card"
            onClick={handleOpenUrl}
            role={data?.url ? 'button' : undefined}
            tabIndex={data?.url ? 0 : -1}
            onKeyDown={(e) => {
                if ((e.key === 'Enter' || e.key === ' ') && data?.url) {
                    e.preventDefault();
                    handleOpenUrl();
                }
            }}
            sx={{ cursor: data?.url ? 'pointer' : 'default' }}
        >
            <Box className="card-header">
                <Box>
                    <Typography variant="h6" className="header-title">
                        {data.title}
                    </Typography>
                </Box>
                <Box className="header-meta">
                    <Typography variant="caption">
                        {data.date}
                    </Typography>
                    <Chip
                        label={data.confidentiality.label}
                        className={`confidentiality-chip ${data.confidentiality.color}`}
                        size="small"
                    />
                </Box>
            </Box>

            <Typography className="section-title">
                <EmailIcon sx={{ fontSize: 16, color: '#a0a0b0' }} />  Contact</Typography>
            <Box className="contact-list">
                {displayedContacts.map((contact, index) => (
                    <Box key={index} className="contact-item">
                        <Typography variant="body2">{contact}</Typography>
                    </Box>
                ))}
                {remainingContacts > 0 && (
                    <Typography className="more-contacts">
                        +{remainingContacts} More
                    </Typography>
                )}
            </Box>
            
            <Typography className="section-title">Description</Typography>
            <Typography className="description-text">
                {renderedDescription}
            </Typography>
            {isLong && (
                <Link
                    component="button"
                    variant="body2"
                    onClick={(e) => { e.stopPropagation(); setIsExpanded(!isExpanded); }}
                    className="view-more-link"
                >
                    {isExpanded ? 'View Less' : 'View More...'}
                </Link>
            )}
        </Box>
    );
}